var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDm = function SvgIconDm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#496E2D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.349 23.77a12.01 12.01 0 0 0 9.421-9.422H14.35zM.23 14.348a12.01 12.01 0 0 0 9.422 9.422v-9.422zM23.77 9.652A12.01 12.01 0 0 0 14.35.23v9.422zM9.652.23A12.01 12.01 0 0 0 .23 9.652h9.422z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFDA44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.218 14.348H9.651v9.422q.767.152 1.566.204zM11.218 9.653V.027q-.799.052-1.566.204v9.422z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.782.027a12 12 0 0 0-1.565 0v9.626h1.565zM11.217 23.974a12 12 0 0 0 1.565 0v-9.626h-1.565z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFDA44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.652 11.218V9.653H.231q-.153.766-.205 1.565zM14.349 11.218h9.626a12 12 0 0 0-.204-1.565h-9.422z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.348 12.783h9.626a12 12 0 0 0 0-1.565h-9.626zM.026 11.218a12 12 0 0 0 0 1.565h9.626v-1.565z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12 17.739a5.74 5.74 0 1 0 0-11.478 5.74 5.74 0 0 0 0 11.478"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#496E2D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.308 12.64c-.427-.853-.982-1.718-.982-1.718s.013-.394.013-.63a.64.64 0 0 0-1.277-.054.505.505 0 0 0-.2.95.73.73 0 0 1 .431-.4.7.7 0 0 0 .102.069l.082.039s-.304.857-.304 1.318c0 1.295.854 1.694.854 1.694v.013l-.427.427h.854v-.854l.427.427c.003-.008.808-.517.426-1.28M12 7.304l.194.598h.628l-.508.37.194.598L12 8.5l-.509.37.194-.598-.508-.37h.628zM9.24 8.202l.509.37.508-.37-.194.598.509.369h-.63l-.193.598-.195-.598h-.628l.508-.37zM7.534 10.55h.629l.194-.599.194.598h.629l-.509.37.195.598-.509-.37-.509.37.195-.598zM7.534 13.451l.509-.37-.195-.597.509.37.509-.37-.195.598.509.37h-.629l-.194.597-.194-.598zM9.24 15.8l.194-.599-.508-.37h.628l.195-.597.194.598h.629l-.509.37.194.597-.508-.37zM12 16.696l-.195-.597h-.628l.508-.37-.194-.598.509.37.508-.37-.194.598.508.37h-.628zM14.76 15.799l-.508-.37-.509.37.194-.598-.508-.37h.628l.195-.597.194.598h.629l-.51.37zM16.466 13.451h-.629l-.194.598-.194-.598h-.629l.509-.37-.194-.597.508.37.509-.37-.194.598zM16.466 10.55l-.508.369.194.598-.509-.37-.508.37.194-.598-.509-.37h.629l.194-.598.194.598zM14.76 8.202l-.194.597.508.37h-.628l-.194.598-.195-.598h-.628l.508-.37-.194-.597.509.37z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconDm;